
//--------------------------------------- Prod-server --------------------------------------------
const PROD_URLS = {
    ADMIN_URL: "https://app.rgconstruction.am/admin/api/v1",
    BASE_URL: "https://app.rgconstruction.am/front/api/v1",
    HOST_MEDIA_URL: "https://app.rgconstruction.am/admin",
}
/*const PROD_URLS = {
    ADMIN_URL: "http://55.133.22.219:3000/api/v1",
    BASE_URL: "http://155.133.22.219:3001/api/v1",
    HOST_MEDIA_URL: "http://155.133.22.219:3000",
}*/

//--------------------------------------- Dev-server --------------------------------------------

const DEV_URLS = {
    ADMIN_URL: "http://173.212.233.220:9240/api/v1",
    BASE_URL: "http://173.212.233.220:9241/api/v1",
    HOST_MEDIA_URL: "http://173.212.233.220:9240",
}

console.log('REACT_APP_WEB_ENVIRONMENT', process.env.REACT_APP_WEB_ENVIRONMENT)
const {BASE_URL, ADMIN_URL, HOST_MEDIA_URL} =
    process.env.REACT_APP_WEB_ENVIRONMENT === 'production' ? PROD_URLS : DEV_URLS;


export const _hostMedia = HOST_MEDIA_URL;
export const _urlLanguage = BASE_URL + "/languages";
export const _urlStaticTexts = ADMIN_URL + "/static-texts";
export const _urlMenu = BASE_URL + "/menu";
export const _urlBadges = BASE_URL + "/badges";
export const _urlBanks = BASE_URL + "/banks";
export const _urlSlider = BASE_URL + "/slider";
export const _urlAbout = BASE_URL + "/about";
export const _urlContact = BASE_URL + "/contact";
export const _urlBuildings = BASE_URL + "/buildings";
export const _urlFloors = BASE_URL + "/floors";
export const _urlAreas = BASE_URL + "/areas";
export const _urlParking = BASE_URL + "/parking";
export const _urlPartners = BASE_URL + "/partners";
export const _urlReservation = BASE_URL + "/reservation";
export const _urlSubscribers = BASE_URL + "/subscribers";
export const _urlAboutSlider = BASE_URL + "/about-slider";
export const _urlWorks = BASE_URL + '/works';
export const _urlCallRequest = BASE_URL + '/call-request';
export const _urlRateList = BASE_URL + '/rates-list';
export const _urlGraphics = BASE_URL + '/graphics';
export const _urlSettings = BASE_URL + '/settings';
export const _urlServices = BASE_URL + '/services';

